/**
 * A wrapper around local storage methods to ensure the user's browser allows/has access
 * to the Storage Web API
 */
export const checkIfBrowserHasLocalStorage = () => {
    let hasAccessToLocalStorage;

    try {
        if (typeof window.localStorage !== 'undefined') {
            window.localStorage.setItem('test', 'testValue');
            window.localStorage.removeItem('test');
            hasAccessToLocalStorage = true;
        } else {
            hasAccessToLocalStorage = false;
        }
    } catch (e) {
        hasAccessToLocalStorage = false;
    }

    return hasAccessToLocalStorage;
};

const localStorageWrapper = {
    setItem: (key, value) => {
        if (!checkIfBrowserHasLocalStorage()) {
            return undefined;
        }

        return window.localStorage.setItem(key, value);
    },
    getItem: (key) => {
        if (!checkIfBrowserHasLocalStorage()) {
            return undefined;
        }

        return window.localStorage.getItem(key);
    },
    removeItem: (key) => {
        if (!checkIfBrowserHasLocalStorage()) {
            return undefined;
        }

        return window.localStorage.removeItem(key);
    },
};

export default localStorageWrapper;
